import { useEffect } from "react";

const message = "Are you sure you want to leave?";

export const usePreventAccidentalPageLeave = (isDirty: boolean) => {
  useEffect(() => {
    const beforeUploadHandler = (event: BeforeUnloadEvent) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = message;
      }
    };
    const beforePageChangeHandler = (event: Event) => {
      if (isDirty && !window.confirm(message)) {
        event.preventDefault();
      }
    };
    window.addEventListener("beforeunload", beforeUploadHandler);
    document.addEventListener(
      "turbolinks:before-visit",
      beforePageChangeHandler,
    );
    return () => {
      window.removeEventListener("beforeunload", beforeUploadHandler);
      document.removeEventListener(
        "turbolinks:before-visit",
        beforePageChangeHandler,
      );
    };
  }, [isDirty]);
};
